/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".active_menu[_ngcontent-%COMP%]{background-color:#007ac9}.disable[_ngcontent-%COMP%]{pointer-events:none;cursor:default;color:#789}.small-loader[_ngcontent-%COMP%]{height:15px;width:15px;display:inline}\n/*# sourceMappingURL=mobile-header.component.css.map*/"];
export { styles as styles };
